import React from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../LoadingIndicator';
import CheckIcon from '../Icons/Check';
import AddIcon from '../Icons/Add';
import { IconSize } from '../Icons/IconWrap';
import s from './CentaurCard.scss';
// This component has been christened CentaurCard because it needs to present
// two very different entities (folders and groups), and had no better idea
export var CentaurCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, thumb = _a.thumb, _b = _a.mode, mode = _b === void 0 ? 'default' : _b, className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], s["mode-" + mode], className) },
        React.createElement("div", { className: classnames(s['thumb'], !thumb && s['empty']) },
            React.createElement("div", { className: s['thumb-content'] }, thumb),
            React.createElement("div", { className: s['overlay'] },
                mode === 'add' && React.createElement(AddIcon, { className: s['icon'] }),
                mode === 'progress' && (React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })),
                ['done', 'selected', 'default'].includes(mode) && (React.createElement(CheckIcon, { className: s['icon'], size: IconSize.SMALL })))),
        React.createElement("div", { className: s['title-block'] },
            React.createElement("div", { className: s['title'] }, title),
            subtitle && React.createElement("span", { className: s['subtitle'] }, subtitle))));
};
CentaurCard.displayName = 'CentaurCard';
export default CentaurCard;
//# sourceMappingURL=CentaurCard.js.map